import React from "react";

export const Logo = ({ size = "md", className = "" }) => {
  const sizes = {
    sm: { box: "w-7 h-7", text: "text-base" },
    md: { box: "w-9 h-9", text: "text-xl" },
    lg: { box: "w-11 h-11", text: "text-2xl" },
  };
  const s = sizes[size] || sizes.md;
  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
      <div
        className={`${s.box} relative rounded-xl flex items-center justify-center overflow-hidden`}
        style={{
          background:
            "radial-gradient(120% 120% at 0% 0%, rgba(57,255,20,0.9) 0%, rgba(0,122,255,0.9) 90%)",
          boxShadow:
            "0 0 20px rgba(57,255,20,0.35), inset 0 0 0 1px rgba(255,255,255,0.18)",
        }}
      >
        <svg viewBox="0 0 32 32" className="w-3/5 h-3/5 text-black" fill="none">
          <path
            d="M22 9.5C20.4 7.9 18.3 7 16 7c-5 0-9 4-9 9s4 9 9 9c2.3 0 4.4-.9 6-2.5"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
          />
          <circle cx="22" cy="16" r="2.4" fill="currentColor" />
        </svg>
      </div>
      <div className="leading-none">
        <div className={`${s.text} font-bold tracking-tight text-white`}>
          Core<span className="text-[#39FF14]">Scale</span>
        </div>
        <div className="text-[10px] tracking-[0.3em] uppercase text-zinc-500 mt-0.5">
          Agency
        </div>
      </div>
    </div>
  );
};

export default Logo;
